// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import parseQueryStringCaseInsensitive from "@insite/client-framework/Common/Utilities/parseQueryStringCaseInsensitive";
import { getSession } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox from "@insite/mobius/Checkbox/Checkbox";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block/Block";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import OrderActions from "@store/Library/Components/Toolkit/Order/OrderActions";
import Button from "@store/MobiusOverrides/Button/Button";
import Link, { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { formGridProps } from "@store/Themes/common/props/form";
import { orderProps } from "@store/Themes/common/props/order";
import getTrackingInfo from "@store/Framework/Store/Store/Pages/OrderDetails/Handlers/GetTrackingInfo";
import setShippingNotification from "@store/Framework/Store/Store/Pages/OrderDetails/Handlers/SetShippingNotification";
import setTrackingInfoReady from "@store/Framework/Store/Store/Pages/OrderDetails/Handlers/SetTrackingInfoReady";
import { loadTrackingInfo } from "@store/Framework/Store/Store/Pages/OrderDetails/StoreOrderDetailsSelectors";
import TextField from "@store/MobiusOverrides/TextField/TextField";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const { session } = state.context;
    const location = getLocation(state);
    let orderNumber = state.pages.orderDetails.orderNumber;
    if (!orderNumber && location && location.search) {
        const parsedQuery = parseQueryStringCaseInsensitive(location.search, {
            orderNumber: "",
        });
        orderNumber = parsedQuery.orderNumber;
    }
    const order = getOrderState(state, orderNumber).value;
    const orderTracking = loadTrackingInfo(state).orderTracking;
    return {
        order,
        orderTracking,
        language: session.language,
    };
};

const mapDispatchToProps = {
    getTrackingInfo,
    setTrackingInfoReady,
    setShippingNotification,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderDetailsShipmentTrackingStyles {
    block?: BlockProps;
    container?: GridContainerProps;
    largeGridItem?: GridItemProps;
    trackingBar?: InjectableCss;
    smallGridItem?: GridItemProps;
    notificationsModal?: ModalPresentationProps;
    statusSection?: InjectableCss;
    statusSectionOn?: InjectableCss;
    bar?: InjectableCss;
    dot?: TypographyPresentationProps;
    info?: InjectableCss;
    name?: TypographyPresentationProps;
    date?: TypographyPresentationProps;
    trackingHeading?: TypographyPresentationProps;
    notificationStatusOn?: TypographyPresentationProps;
    notificationStatus?: TypographyPresentationProps;
    manageNotificationsLink?: LinkPresentationProps;
    errorMessage?: InfosBoxProps;
    successMessage?: InfosBoxProps;
}

export const orderDetailsShipmentTrackingStyles: OrderDetailsShipmentTrackingStyles = {
    block: orderProps.block,
    largeGridItem: {
        width: [12, 12, 12, 9, 9],
    },
    smallGridItem: {
        width: [12, 12, 12, 3, 3],
        css: css`
            border-left: ${pxToRem(1)} solid ${getColor("common.border")};
        `,
    },
    trackingBar: {
        css: css`
            position: relative;
            display: table;
            width: 100%;
            padding-left: ${pxToRem(8)};
            margin: ${pxToRem(-10)} 0;

            ${breakpoint("sm")} {
                padding: ${pxToRem(8)} 0 0;
                margin: 0;
                table-layout: fixed;
            }
        `,
    },
    statusSection: {
        css: css`
            display: table-row;
            vertical-align: middle;
            height: ${pxToRem(62)};
            padding: ${pxToRem(20)} 0;

            &:first-child {
                text-align: left;

                & > ${StyledWrapper}::before {
                    display: none;
                }
            }

            &:last-child {
                text-align: right;

                & > ${StyledWrapper}::after {
                    display: none;
                }
            }

            ${breakpoint("sm")} {
                display: table-cell;
                vertical-align: top;
                height: auto;
                padding: 0;
                text-align: center;

                &:first-child {
                    & > ${StyledWrapper}::after {
                        right: ${pxToRem(-2)};
                        left: ${pxToRem(30)};
                    }

                    & > ${StyledWrapper} > ${TypographyStyle as any} {
                        margin-left: ${pxToRem(8)};
                    }
                }

                &:last-child {
                    & > ${StyledWrapper}::before {
                        right: ${pxToRem(30)};
                        left: 0;
                    }

                    & > ${StyledWrapper} > ${TypographyStyle as any} {
                        margin-right: ${pxToRem(8)};
                    }
                }
            }
        `,
    },
    statusSectionOn: {
        css: css`
            &
                > ${StyledWrapper}
                > ${TypographyStyle as any}::before,
                &
                > ${StyledWrapper}
                > ${TypographyStyle as any}::after {
                position: absolute;
                top: 50%;
                left: 50%;
                -webkit-transform: translate3d(-50%, -50%, 0);
                transform: translate3d(-50%, -50%, 0);
            }

            & ~ ${StyledWrapper} > ${StyledWrapper} {
                color: ${getColor("common.border")};
            }

            & > ${StyledWrapper}::after {
                border-radius: ${pxToRem(6)};
            }

            & > ${StyledWrapper} > ${TypographyStyle as any}::before {
                content: "";
                width: ${pxToRem(44)};
                height: ${pxToRem(44)};
                border-radius: 50%;
                box-shadow: 0 ${pxToRem(2)} ${pxToRem(4)} rgba(0, 0, 0, 0.2);
                background-color: ${getColor("secondary")};
            }

            & > ${StyledWrapper} > ${TypographyStyle as any}::after {
                content: "";
                font-family: icons, sans-serif;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
                color: ${getColor("primary.contrast")};
                font-size: 28px;
            }
        `,
    },
    bar: {
        css: css`
            position: relative;
            width: 0.1%;
            color: ${getColor("secondary")};
            line-height: 0;

            &::before,
            &::after {
                content: "";
                position: absolute;
                left: 50%;
                display: block;
                width: ${pxToRem(6)};
                background-color: currentcolor;
                -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
            }

            &::before {
                top: 0;
                bottom: calc(50% + 8px);
                z-index: 1;
            }

            &::after {
                top: calc(50% + 8px);
                bottom: -2px;
                z-index: 2;
            }

            ${breakpoint("sm")} {
                display: block;
                padding: 0;
                width: auto;

                &::before,
                &::after {
                    top: 50%;
                    bottom: auto;
                    left: auto;
                    width: auto;
                    height: ${pxToRem(6)};
                    -webkit-transform: translateY(-50%);
                    transform: translateY(-50%);
                }

                &::before {
                    right: calc(50% + 8px);
                    left: 0;
                }

                &::after {
                    right: -2px;
                    left: calc(50% + 8px);
                }
            }
        `,
    },
    dot: {
        css: css`
            position: relative;
            z-index: 3;
            display: block;
            width: ${pxToRem(26)};
            height: ${pxToRem(26)};
            border: ${pxToRem(6)} solid currentcolor;
            border-radius: 50%;

            ${breakpoint("sm")} {
                display: inline-block;
            }
        `,
    },
    info: {
        css: css`
            padding-top: ${pxToRem(15)};
        `,
    },
    name: {
        weight: "bold",
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    trackingHeading: {
        ...formGridProps.title,
        mergeCss: true,
        css: css`
            margin-bottom: 0;
        `,
    },
    notificationStatus: {
        forwardAs: "p",
        css: css`
            color: ${getColor("danger")};
            font-style: italic;
            font-size: ${x => x.theme.design.typography.size.smaller};

            &::before {
                content: "";
                font-family: icons, sans-serif;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
                position: relative;
                top: 0.05em;
                margin-right: 0.2em;
            }
        `,
    },
    notificationStatusOn: {
        forwardAs: "p",
        css: css`
            color: ${getColor("success")};
            font-style: italic;
            font-size: ${x => x.theme.design.typography.size.smaller};

            &::before {
                content: "";
                font-family: icons, sans-serif;
                font-weight: normal;
                font-style: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
                position: relative;
                top: 0.05em;
                margin-right: 0.2em;
            }
        `,
    },
    manageNotificationsLink: {
        css: css`
            ${linkStyles("text.link", "text.linkHover", true, true)}
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    errorMessage: { type: "error" },
    successMessage: { type: "success" },
};

const styles = orderDetailsShipmentTrackingStyles;

const statusOnCss = css`
    & span[data-test-selector="dot"]::before,
    & span[data-test-selector="dot"]::after {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
    }

    & ~ ${StyledWrapper} > ${StyledWrapper} {
        color: ${getColor("common.border")};
    }

    & > ${StyledWrapper}::after {
        border-radius: 6px;
    }

    & span[data-test-selector="dot"]::before {
        content: "";
        width: 44px;
        height: 44px;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        background-color: ${getColor("secondary")};
    }

    & span[data-test-selector="dot"]::after {
        content: "";
        font-family: icons, sans-serif;
        font-weight: normal;
        font-style: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        color: ${getColor("primary.contrast")};
        font-size: 28px;
    }
`;

export interface OrderDetailsShipmentTrackingType {
    default: boolean;
    pickup: boolean;
    dqt: boolean;
    other: boolean;
}

export interface OrderDetailsShipmentTrackingStatus {
    processing: boolean;
    shipped: boolean;
    transit: boolean;
    delivered: boolean;
}

// It is impossible to use this locally
// You can use the following to test
// Replace all occurences of orderTracking.trackingInfo? for debugTrackingInfo
// then set type.dqt to true
/*
export interface OrderDetailsShipmentTrackingTrackingInfo {
    uri: string;
    arrivalTime: Date | string;
    departureTime: Date | string;
    estimatedTimeOfArrival: string;
    status: string;
    tripTimeOut: Date | string;
    properties: any;
}
const debugTrackingInfo = {
    uri: null,
    arrivalTime: "2024-02-05T18:03:00+00:00",
    departureTime: "2024-02-05T18:07:00+00:00",
    estimatedTimeOfArrival: "2024-02-05T18:01:25.897+00:00",
    status: "in transit",
    tripTimeOut: "2024-02-05T10:28:00+00:00",
    properties: {},
};
*/

const OrderDetailsShipmentTracking = ({
    order,
    orderTracking,
    language,
    getTrackingInfo,
    setTrackingInfoReady,
    setShippingNotification,
}: Props) => {
    const [type, setType] = useState<OrderDetailsShipmentTrackingType>({
        default: false,
        pickup: false,
        dqt: true,
        other: false,
    });
    const [status, setStatus] = useState<OrderDetailsShipmentTrackingStatus>({
        processing: true,
        shipped: false,
        transit: false,
        delivered: false,
    });
    const [erpOrderNumber, setErpOrderNumber] = useState(order?.erpOrderNumber || "");
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const [newNotificationsEmail, setNewNotificationsEmail] = useState("");
    const [showNewNotificationEmailField, setShowNewNotificationEmailField] = useState<boolean>(
        orderTracking.newEmailNotificationsState || false,
    );

    useEffect(() => {
        if (orderTracking) {
            const status: OrderDetailsShipmentTrackingStatus = {
                processing: false,
                shipped: false,
                transit: false,
                delivered: false,
            };
            status.delivered = orderTracking.trackingInfo?.status?.toLowerCase() === "delivered";
            status.processing =
                orderTracking.trackingInfo?.status?.toLowerCase() === "not shipped" ||
                orderTracking.trackingInfo?.status?.length === 0;
            status.transit = orderTracking.trackingInfo?.status?.toLowerCase() === "in transit";
            status.shipped = false;
            setTrackingInfoReady({ ready: true });
            setShowNewNotificationEmailField(orderTracking.newEmailNotificationsState || false);
            setStatus(status);
        }
    }, [orderTracking, order]);

    useEffect(() => {
        if (order) {
            const type: OrderDetailsShipmentTrackingType = {
                default: false,
                pickup: false,
                dqt: false,
                other: false,
            };
            type.pickup =
                order.properties["shipmentTracker"] === "Pickup" || order.properties["shipViaIsPickup"] === "true";
            type.dqt = order.properties["shipmentTracker"] === "DQ";
            type.other =
                order.properties["shipmentTracker"] === "Third Party" ||
                order.properties["shipmentTracker"] === "Part Runner";
            type.default = !(type.pickup || type.dqt || type.other);
            setErpOrderNumber(order?.erpOrderNumber);

            if (type.dqt) {
                getTrackingInfo({ erpOrderNumber });
            } else {
                if (order.status === "Shipped" || order.status === "Invoiced" || order.status === "Paid") {
                    setStatus({ ...status, processing: false, shipped: true });
                }
                setTrackingInfoReady({ ready: true });
            }
            setType(type);
        }
    }, [order]);

    if (!order || type.pickup) {
        return null;
    }

    const handleNotificationsLink = () => {
        setModalIsOpen(true);
    };

    const modalCloseHandler = () => {
        setModalIsOpen(false);
        setShowNewNotificationEmailField(false);
    };

    const handleNewNotificationEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewNotificationsEmail(event.target.value);
    };

    const handleNewNotificationCheckbox = () => {
        setShowNewNotificationEmailField(!showNewNotificationEmailField);
    };

    const updateShippingNotification = () => {
        setShippingNotification({
            erpOrderNumber,
            newEmailNotificationsState: showNewNotificationEmailField,
            newNotificationsEmail,
        });
    };
    const processingStatusOnCss = mergeProps<OrderDetailsShipmentTrackingStyles["statusSection"]>(
        styles.statusSection,
        {
            css: status.processing ? statusOnCss : css``,
        },
    );
    const shippedStatusOnCss = mergeProps<OrderDetailsShipmentTrackingStyles["statusSection"]>(styles.statusSection, {
        css: status.shipped ? statusOnCss : css``,
    });
    const inTransitStatusOnCss = mergeProps<OrderDetailsShipmentTrackingStyles["statusSection"]>(styles.statusSection, {
        css: status.transit || (status.shipped && !type.other) ? statusOnCss : css``,
    });
    const deliveredStatusOnCss = mergeProps<OrderDetailsShipmentTrackingStyles["statusSection"]>(styles.statusSection, {
        css: status.delivered ? statusOnCss : css``,
    });

    return (
        <Block {...styles.block}>
            <GridContainer {...styles.container}>
                <GridItem {...styles.largeGridItem}>
                    <StyledWrapper {...styles.trackingBar} data-test-selector="status-bar">
                        <StyledWrapper {...processingStatusOnCss} data-test-selector="status">
                            <StyledWrapper {...styles.bar} data-test-selector="bar">
                                <Typography {...styles.dot} data-test-selector="dot" />
                            </StyledWrapper>
                            {(status.processing || type.other) && (
                                <StyledWrapper {...styles.info} data-test-selector="info">
                                    <Typography {...styles.name} data-test-selector="name">
                                        {translate("Processing")}
                                    </Typography>
                                </StyledWrapper>
                            )}
                            {!status.processing && !type.other && (
                                <StyledWrapper {...styles.info} data-test-selector="info">
                                    <Typography {...styles.name} data-test-selector="name">
                                        {translate("Shipped")}
                                    </Typography>
                                    {orderTracking.trackingInfo?.tripTimeOut && (
                                        <Typography {...styles.date} data-test-selector="date">
                                            {orderTracking.trackingInfo?.tripTimeOut &&
                                                getLocalizedDateTime({
                                                    dateTime: new Date(orderTracking.trackingInfo?.tripTimeOut),
                                                    language,
                                                    options: {
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                        hour: "numeric",
                                                        minute: "numeric",
                                                    },
                                                })}
                                        </Typography>
                                    )}
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                        {type.other && (
                            <StyledWrapper {...shippedStatusOnCss} data-test-selector="status">
                                <StyledWrapper {...styles.bar} data-test-selector="bar">
                                    <Typography {...styles.dot} data-test-selector="dot" />
                                </StyledWrapper>
                                <StyledWrapper {...styles.info} data-test-selector="info">
                                    <Typography {...styles.name} data-test-selector="name">
                                        {translate("Shipped")}
                                    </Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                        {(type.default || type.dqt) && (
                            <StyledWrapper {...inTransitStatusOnCss} data-test-selector="status">
                                <StyledWrapper {...styles.bar} data-test-selector="bar">
                                    <Typography {...styles.dot} data-test-selector="dot" />
                                </StyledWrapper>
                                <StyledWrapper {...styles.info} data-test-selector="info">
                                    <Typography {...styles.name} data-test-selector="name">
                                        {translate("In Transit")}
                                    </Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                        {(type.default || type.dqt) && (
                            <StyledWrapper {...deliveredStatusOnCss} data-test-selector="status">
                                <StyledWrapper {...styles.bar} data-test-selector="bar">
                                    <Typography {...styles.dot} data-test-selector="dot" />
                                </StyledWrapper>
                                <StyledWrapper {...styles.info} data-test-selector="info">
                                    <Typography {...styles.name} data-test-selector="name">
                                        {status.delivered ? translate("Delivered") : translate("Delivery")}
                                    </Typography>
                                    {orderTracking.trackingInfo?.estimatedTimeOfArrival && (
                                        <Typography {...styles.date} data-test-selector="date">
                                            {`${translate("Estimated")}: ${
                                                orderTracking.trackingInfo?.estimatedTimeOfArrival &&
                                                getLocalizedDateTime({
                                                    dateTime: new Date(
                                                        orderTracking.trackingInfo?.estimatedTimeOfArrival,
                                                    ),
                                                    language,
                                                    options: {
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                        hour: "numeric",
                                                        minute: "numeric",
                                                    },
                                                })
                                            }`}
                                        </Typography>
                                    )}
                                    {orderTracking.trackingInfo?.departureTime && (
                                        <Typography {...styles.date} data-test-selector="date">
                                            {orderTracking.trackingInfo?.departureTime &&
                                                getLocalizedDateTime({
                                                    dateTime: new Date(orderTracking.trackingInfo?.departureTime),
                                                    language,
                                                    options: {
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                        hour: "numeric",
                                                        minute: "numeric",
                                                    },
                                                })}
                                        </Typography>
                                    )}
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.smallGridItem}>
                    {status.delivered ? (
                        <StyledWrapper>
                            <Typography>{translate("Delivered On")}: </Typography>
                            <Typography>
                                {orderTracking.trackingInfo?.departureTime &&
                                    getLocalizedDateTime({
                                        dateTime: new Date(orderTracking.trackingInfo?.departureTime),
                                        language,
                                        options: {
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                        },
                                    })}
                            </Typography>
                        </StyledWrapper>
                    ) : (
                        <StyledWrapper>
                            <Typography {...styles.trackingHeading}>
                                {type.other ? "Tracking Information" : "Expected Delivery Date"}
                            </Typography>
                            <Typography
                                variant="p"
                                color={
                                    orderTracking.trackingInfo?.estimatedTimeOfArrival ? "text.main" : "text.disabled"
                                }
                            >
                                {(orderTracking.trackingInfo?.estimatedTimeOfArrival &&
                                    getLocalizedDateTime({
                                        dateTime: new Date(orderTracking.trackingInfo?.estimatedTimeOfArrival),
                                        language,
                                        options: {
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                        },
                                    })) ??
                                    "Unavailable"}
                            </Typography>
                            {(type.dqt || type.default) && (
                                <>
                                    <Typography
                                        {...(orderTracking.newEmailNotificationsState
                                            ? styles.notificationStatusOn
                                            : styles.notificationStatus)}
                                    >
                                        {translate("Email Notifications Status")}
                                    </Typography>
                                    <Link onClick={handleNotificationsLink} {...styles.manageNotificationsLink}>
                                        {translate("Manage Notifications")}
                                    </Link>
                                </>
                            )}
                        </StyledWrapper>
                    )}
                </GridItem>
            </GridContainer>
            <Modal
                {...styles.notificationsModal}
                headline={translate("Order Notifications")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                {orderTracking.showNotificationErrorMessage && (
                    <InfosBox {...styles.errorMessage}>{translate("Error message")}</InfosBox>
                )}
                {orderTracking.showNotificationSuccessMessage && (
                    <InfosBox {...styles.successMessage}>{translate("Success message")}</InfosBox>
                )}
                <Checkbox checked={showNewNotificationEmailField} onChange={handleNewNotificationCheckbox} />
                {showNewNotificationEmailField && (
                    <TextField
                        label="Email Notifications Label"
                        value={newNotificationsEmail}
                        onChange={handleNewNotificationEmail}
                    />
                )}
                {!type.dqt && <Typography>{translate("Email Notification Warning")}</Typography>}
                <OrderActions>
                    <Button onClick={updateShippingNotification}>{translate("Submit")}</Button>
                    <Button variant="secondary">{translate("Cancel")}</Button>
                </OrderActions>
            </Modal>
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderDetailsShipmentTracking),
    definition: {
        group: "Order Details",
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        displayName: "Shipment Tracking",
    },
};

export default widgetModule;
